import { $http } from '@/utils';

/**
 * @namespace Service
 * @class WriteRoute
 * @exports Service/App/Matter/WriteRoute
 * @description API App Matter WriteRoute Service
 * @date 2023/09/25
 * @license no license
 * @copywrite Answers In Retirement Limited
 */
export default class WriteRoute {
	/**
	 * @static @name list
	 * @description Get all fact finds
	 * @param {Object} payload
	 * @returns {Object} Promise a http response
	 */
	static async list(payload) {
		return $http.post('write-route/hydrated-list', payload);
	}

	/**
	 * @static @name get
	 * @description Get fact find details for ID
	 * @param {String} id
	 * @returns {Object} Promise a http response
	 */
	static get(id) {
		return $http.get(`write-route/${id}`);
	}

	/**
	 * @name downloadFile
	 * @description Get a pre-signed S3 URL for downloading a fact-find document
	 * @param {String} executionId - The execution the file belongs to
	 * @param {String} resource - The resource identifier of the file
	 * @param {String} filename - The name of the file
	 * @returns {Object} Promise a http response containing { preSignedUrl }
	 */
	static downloadFile(executionId, resource, filename) {
		return $http.get(`write-route/file?executionId=${encodeURIComponent(executionId)}&resource=${encodeURIComponent(resource)}&filename=${encodeURIComponent(filename)}`);
	}

	static exportFactFind(id, { compliance = false } = {}) {
		return $http.get(`write-route/export-json/${id}`, { params: { compliance } });
	}
}
